export const OPERATIONAL_REPORT_TYPE = 'operational';
export const REGISTRY_REPORT_TYPE = 'registry';
